import React from 'react';


const About = () => {
  return (
    <div id="about" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="text-base/7 font-semibold tracking-wide text-gold">Your Trusted Insurance Broker</h2>
          <p className="mt-2 text-pretty font-serif text-4xl font-semibold tracking-tight text-navy-dark sm:text-5xl lg:text-balance">
            Protection That Grows With You
          </p>
          <p className="mt-6 text-lg/8 text-gray-600">
            Over 19 years of expertise in securing what matters most—tailored insurance and risk solutions for individuals and businesses alike, backed by strong relationships across Belize's insurance market.
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-5xl">
          <dl className="grid grid-cols-1 sm:grid-cols-2 border border-gray-200 divide-y divide-gray-200 sm:divide-y-0 sm:divide-x">
            <div className="p-8">
              <dt className="flex items-center gap-4 text-base font-semibold text-navy-dark">
                <svg className="size-6 shrink-0 text-navy" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z" />
                  </svg>
                Customized Coverage
              </dt>
              <dd className="mt-3 text-base/7 text-gray-600">
                Tailored insurance programs for corporate and personal clients across industries.
              </dd>
            </div>
            <div className="p-8">
              <dt className="flex items-center gap-4 text-base font-semibold text-navy-dark">
                <svg className="size-6 shrink-0 text-navy" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z" />
                  </svg>
                Proven Expertise
              </dt>
              <dd className="mt-3 text-base/7 text-gray-600">
                Over 19 years of industry-leading experience in risk management and insurance solutions.
              </dd>
            </div>
            <div className="p-8">
              <dt className="flex items-center gap-4 text-base font-semibold text-navy-dark">
                <svg className="size-6 shrink-0 text-navy" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                  </svg>
                Broad Market Access
              </dt>
              <dd className="mt-3 text-base/7 text-gray-600">
                Strong relationships across Belize's insurers let us compare coverage and match you to the right fit.
              </dd>
            </div>
            <div className="p-8">
              <dt className="flex items-center gap-4 text-base font-semibold text-navy-dark">
                <svg className="size-6 shrink-0 text-navy" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33" />
                  </svg>
                Commitment to You
              </dt>
              <dd className="mt-3 text-base/7 text-gray-600">
                Dedicated to providing innovative solutions and exceptional service to safeguard your future.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
};

export default About;
